import { useState } from 'react';
import { Flag, X, Send } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ErrorReportButton({ question }) {
  const [showModal, setShowModal] = useState(false);
  const [errorDescription, setErrorDescription] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // If no question provided, don't render the button
  if (!question) {
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.post(`${API}/error-reports`, null, {
        params: {
          question_id: question?.id || question?.question_number || 'unknown',
          question_number: question?.question_number || 'N/A',
          error_description: errorDescription
        }
      });
      alert('✅ Hata bildirimi alındı, teşekkür ederiz!');
      setShowModal(false);
      setErrorDescription('');
    } catch (error) {
      alert('❌ Hata bildirimi gönderilemedi. Lütfen tekrar deneyin.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className="flex items-center gap-2 px-4 py-2 bg-red-100 hover:bg-red-200 text-red-700 rounded-xl font-semibold text-sm transition-all"
        title="Hata Bildir"
      >
        <Flag className="w-4 h-4" />
        Hata Bildir
      </button>

      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
          <div className="bg-gray-800 rounded-2xl max-w-lg w-full p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-white flex items-center gap-2">
                <Flag className="w-6 h-6 text-red-400" />
                Hata Bildir
              </h3>
              <button
                onClick={() => setShowModal(false)}
                className="bg-white/10 hover:bg-white/20 text-white p-2 rounded-lg transition-all"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="mb-4 p-3 bg-white/5 rounded-lg">
              <p className="text-white/70 text-sm mb-1">
                <strong className="text-white">Soru Numarası:</strong> {question?.question_number || 'N/A'}
              </p>
              <p className="text-white/70 text-sm">
                <strong className="text-white">Soru:</strong> {question?.question_text ? question.question_text.substring(0, 100) + '...' : 'N/A'}
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <label className="block text-white font-semibold mb-2">
                Hatayı Açıklayın *
              </label>
              <textarea
                value={errorDescription}
                onChange={(e) => setErrorDescription(e.target.value)}
                className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-red-500 min-h-[120px]"
                placeholder="Örn: Doğru cevap yanlış işaretlenmiş, seçenek metni hatalı, vb..."
                required
              />

              <div className="flex gap-3 justify-end mt-4">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="px-6 py-3 bg-white/10 hover:bg-white/20 text-white rounded-xl font-semibold transition-all"
                >
                  İptal
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="px-6 py-3 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white rounded-xl font-bold transition-all flex items-center gap-2 disabled:opacity-50"
                >
                  <Send className="w-5 h-5" />
                  {isSubmitting ? 'Gönderiliyor...' : 'Gönder'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
